// import { Link } from '@material-ui/core'
import { Alert, Chip, ComponentVersionsInherit, styled } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { useField } from 'react-final-form'
import { useIsGoogleLeadProject } from '../useIsGoogleLeadProject'

export const GoogleLeadProjectSection = ({ children }) => {
  const isGoogleLeadProject = useIsGoogleLeadProject()
  return isGoogleLeadProject ? <>{children}</> : null
}

export const GoogleLeadSoldWarningSection = ({ children }) => {
  const isGoogleLeadProject = useIsGoogleLeadProject()

  const {
    input: { value: project_sold },
  } = useField('project_sold', { subscription: { value: true } })

  const {
    input: { value: specified_price_of_solar },
  } = useField('custom_data._google_leads.specified_price_of_solar', { subscription: { value: true } })

  const {
    input: { value: specified_price_of_battery },
  } = useField('custom_data._google_leads.specified_price_of_battery', { subscription: { value: true } })

  const {
    input: { value: specified_price_of_others },
  } = useField('custom_data._google_leads.specified_price_of_others', { subscription: { value: true } })

  const pricingFieldMissing = !specified_price_of_solar || !specified_price_of_battery || !specified_price_of_others
  const showWarning = isGoogleLeadProject && project_sold && pricingFieldMissing

  return showWarning ? <>{children}</> : null
}

export const GoogleLeadProjectBanner = () => {
  return (
    <GoogleLeadProjectSection>
      <GoogleLeadProgramBanner />
    </GoogleLeadProjectSection>
  )
}

export const GoogleLeadProgramBanner = () => {
  const translate = useTranslate()
  return (
    <Alert
      severity="success"
      variant="filled"
      primaryButtonLabel={translate('See Program Details')}
      onClickPrimaryButton={() => {
        window.open(
          'https://support.opensolar.com/hc/en-us/articles/12380603360655-Google-Leads-Pilot-Program-US',
          '_blank'
        )
      }}
    >
      {translate('Google Lead | Pilot Program')}
    </Alert>
  )
}

export const GoogleLeadSoldBanner = () => {
  const translate = useTranslate()
  return (
    <GoogleLeadSoldWarningSection>
      <Alert severity="error" variant="filled">
        {translate('Google Lead Action Required: Record sold deal pricing for Solar, Battery and Other items.')}
      </Alert>
    </GoogleLeadSoldWarningSection>
  )
}

export const GoogleLeadChip = ({ isWarning = false, label = 'Google Lead | Pilot Program', ...rest }) => {
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={{ chip: 2 }}>
      <Chip
        variant="filled"
        color={isWarning ? 'error' : 'success'}
        label={translate(label)}
        size={'small'}
        {...rest}
      />
    </ComponentVersionsInherit>
  )
}

export const BannersContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  marginBottom: theme.spacing(2),
}))

export const FlexRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  flexWrap: 'wrap',
  alignItems: 'center',
}))
